<template>
    <div
        class="modal fade"
        id="deleteFirmModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="staticBackdropLabel">Smazání firmy</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <p>
                        Opravdu chcete smazat tuto firmu: <b>{{ this.firmName }}</b> ?
                    </p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Zrušit</button>
                    <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="DeleteFirm">Smazat</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
export default {
    name: "DeleteFirmModal",
    props: ["firmId", "firmName"],
    methods: {
        async DeleteFirm() {
            await axios.delete("http://admin.contactweb.cz/api/firms?firmId=" + this.firmId, {
                headers: { Authorization: "Bearer " + localStorage.getItem("token") },
            });
            const response = await axios.get("http://admin.contactweb.cz/api/firms", {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            });
            this.$emit("refresh", response.data);
            this.$moshaToast("Firma smazána.", { type: "warning" });
        },
    },
};
</script>
